module.exports = __webpack_public_path__ + "static/media/hack_red.02832ed5.jpg";